import React, { useEffect, useRef, useState } from "react";
import { Menu, Modal, Popover, notification } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import SockJS from "sockjs-client";
import { over } from "stompjs";
import { jwtDecode } from "jwt-decode";
import { doLogout } from "../../utils/utils";
import ProfilePopup from "../../screens/popupprofile/profile";
import { UrlConstants } from "../../utils/ApiConstants";
import { GetRequest } from "./../../utils/api";
import AppNotification from "../../components/AppNotification/AppNotification";
import { userProfileApis } from "../../utils/ApiURLs";
import CustomIcon from "../icons/CustomIcon";
import VernacularDropDown from "../../vernacular";
import ThemeEditor from '../../components/ThemeEditor';
import { getImage } from "../../utils/getFile";

const WEB_SOCKET_BACKEND_URL = `${UrlConstants.BASE_URL}notifications/ws?authtoken=`; //'http://localhost:8085/ws';
let stompClient: any = {};
interface Props {
  showSideDrawer: boolean;
  isShowSideDrawer: (value: any) => void;
}

const PlatformHeader: React.FC<Props> = ({ isShowSideDrawer, showSideDrawer }) => {

  const userDetails = JSON.parse(localStorage?.getItem("user") || "{}");
  const { username, roleName, userType, name } = userDetails;
  const navigate = useNavigate();

  const [showProfilePopup, setShowProfilePopup] = useState(false);
  const [showThemeEditor, setShowThemeEditor] = useState(false);
  const [userData, setUserData] = useState({});

  const handleProfilePopup = () => {
    GetProfieData();
    setShowProfilePopup(!showProfilePopup);
  };

  let profileId = useRef("ADMIN");

  const handleLogoClickNavigation = () => {
    navigate("/login");
  }

  // Navigate to logout only after logout success....
  useEffect(() => {
    if (!localStorage.getItem("user")) {
      navigate("/login");
    } else {
      // Here we should subscribe to notifications
      const userInLocalStorageStr: any = localStorage.getItem("user");
      const user = JSON.parse(userInLocalStorageStr);
      subscribeForNotificationsViaWebSocket(user.accessToken);
      if (userType !== 'External') {
        GetProfieData();
      }

      const decodedToken: any = jwtDecode(user.accessToken);
      ;
      profileId.current = decodedToken.profileId;

    }
  }, []);

  function subscribeForNotificationsViaWebSocket(accessToken: string) {
    let sock = new SockJS(WEB_SOCKET_BACKEND_URL + accessToken);
    stompClient = over(sock);
    stompClient.connect({ headers: { 'Authorization': `Bearer ${accessToken}` } }, () => onNotificationsWebSocketConnected(accessToken), onNotificationsWebSocketError);
  }

  function onNotificationsWebSocketConnected(accessToken: string) {
    // Let's decode the accessToken and fetch the respective ecode and clientId
    const decodedToken: any = jwtDecode(accessToken);

    const clientId = decodedToken.clientId;
    const ecode = decodedToken.ecode;
    stompClient.subscribe(
      `/topic/notifications/subscribe/${ecode}/${clientId}/${Date.now()}`,
      handleOnMessageReceived,
      {
        id: "notifications-ws-topic-1",
        headers: {
          Authorization: accessToken
        }
      }
    );
  }

  const handleOnMessageReceived = (msg: any) => {
    notification.info({
      message: 'Notification',
      description: msg.body,
      duration: 5
    });
  };

  function onNotificationsWebSocketError() {
    console.log("Error came while setting up Notifications...");
  }


  const logout = async () => {
    await doLogout();
    navigate("/login");

  }


  const logoutConfirmation = () =>
    Modal.confirm({
      title: "Logout",
      content: "Do you wish to logout?",
      okText: "Yes",
      okButtonProps: {
        className: "bg-primary"
      },
      cancelButtonProps: {
        className: "border-primary text-primary"
      },
      cancelText: "Cancel",
      onOk: () => logout(),
    });

  const overlayMenu = () => (
    <Menu className="bg-white border-0" defaultSelectedKeys={[]} selectedKeys={[]} >
      {userType !== 'External' ? <>
        <Menu.Item className="my-0 bg-white">
          <a onClick={handleProfilePopup}> <CustomIcon name="user"></CustomIcon> &nbsp; My Info</a>
        </Menu.Item>
        <Menu.Item className="my-0 ng-white">
          <a onClick={() => navigate("/changePassword")}> <CustomIcon name={"changePassword"}></CustomIcon> &nbsp; Change Password</a>
        </Menu.Item>
      </> : <></>
      }
      <Menu.Item className="my-0 bg-white">
        <a onClick={logoutConfirmation}> <CustomIcon name="logout"></CustomIcon> &nbsp; Logout</a>
      </Menu.Item>
    </Menu>
  );

  const GetProfieData = async () => {
    try {
      GetRequest(userProfileApis.myinfoApi).then((result) => {
        setUserData(result);
      });
    } catch (error) {
      console.log('Error fetching data:', error);
    }
  };

  return (
    <div className="platform-header">


      <div>
        <ProfilePopup
          visible={showProfilePopup}
          onCancel={handleProfilePopup}
          user={userData}
        />
      </div>
      <div className="w-100 justify-content-between">
        <div className="text-primary d-flex justify-content-between items-center">
          <span className="pl-2 pl-lg-4 pr-2 pointer" onClick={() => isShowSideDrawer(!showSideDrawer)} >
            <FontAwesomeIcon
              icon={faBars}
              style={{ height: "24px" }}
            />
          </span>
          <span onClick={() => handleLogoClickNavigation()} className="pointer mx-2">
            <img style={{ height: "50px", width: "50px", display: "initial" }} src={getImage('header-logo.png')}></img>
          </span>

        </div>

        <div className="pr-2">

          <div style={{ lineHeight: 3.5 }}>

            <div className="d-flex">
            <CustomIcon className="mr-2 align-middle" onClick={() => setShowThemeEditor(true)} name="filter"  />

              <VernacularDropDown />


              <AppNotification></AppNotification>

              <Popover className="mr-2" placement={"bottomRight"} showArrow={false} content={<div className="mr-2 mt-2"> {overlayMenu()}</div>}>

                <span>
                  {/* <FontAwesomeIcon icon={faUser} className="header-col d-inline" style={{ marginRight: "10px", fontSize: "15px" }} /> */}
                  <CustomIcon name="user" className="header-col d-inline" style={{ marginRight: "10px" }}></CustomIcon>
                  {userType === 'External' ? (<>
                    <span className="text-primary text-center mr-3" style={{ lineHeight: 1.4, display: "inline-flex", flexDirection: "column" }}>
                      <span>{name}</span>
                      <span>{username}</span>
                    </span>
                  </>) : <>

                    <span className="text-primary text-center mr-3" style={{ lineHeight: 1.4, display: "inline-flex", flexDirection: "column" }}>
                      <span>{username}</span>
                      <span>{roleName}</span>
                    </span>

                  </>
                  }
                </span>
              </Popover>
            </div>


          </div>

        </div>
      </div>

      <Modal
        className="hide-on-mobile"
        title="Theme Editor"
        open={showThemeEditor}
        onCancel={() => setShowThemeEditor(false)}
        footer={null}
        width={800}
      >
        <ThemeEditor />
      </Modal>
    </div>
  );
};

export default PlatformHeader;
